module.exports = "/_next/static/resources/photo-1-a6cf714a33d07c7a0362f7d92deef033.webp";